"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XMLSerializer = void 0;
// Export classes
var XMLSerializerImpl_1 = require("./XMLSerializerImpl");
Object.defineProperty(exports, "XMLSerializer", { enumerable: true, get: function () { return XMLSerializerImpl_1.XMLSerializerImpl; } });
//# sourceMappingURL=index.js.map